import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarIcon from "../../../assets/substratum-protocol/navbar-icon-substratum-protocol.webp";

const session01To10Links = [
  {
    href: "/substratum-protocol-session-03",
    label: "03: The Gravity of Darkness [09-26-2026]",
  },
  {
    href: "/substratum-protocol-session-02",
    label: "02: The Star in the Jar [09-12-2026]",
  },
  {
    href: "/substratum-protocol-session-01",
    label: "01: The Earth Is Breaking [08-28-2026]",
  },
];

// const toolsLinks = [
//   { href: "/blade-runner-overview", label: "Blade Runner Overview" },
//   { href: "/blade-runner-classes", label: "Blade Runner Classes" },
//   { href: "/blade-runner-rules", label: "Blade Runner Rules" },
// ];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const SPNavBar = () => {
  return (
    <NavDropdown
      title="Substratum Protocol"
      id="substratum-protocol-nav-dropdown"
    >
      <NavDropdown.Header>
        <div style={{ textAlign: "center" }}>The Earth is Breaking</div>
      </NavDropdown.Header>
      <NavDropdown.Header>
        <img
          src={NavBarIcon}
          alt="Substratum Protocol"
          style={{ maxHeight: 85 }}
        />
      </NavDropdown.Header>
      {/* 
      <NavDropdown title="Sessions 11-20" id="blade-runner-sessions-11-20">
        {renderLinks(session11To20Links)}
      </NavDropdown> */}

      <NavDropdown title="Sessions 01-10" id="blade-runner-sessions-01-10">
        {renderLinks(session01To10Links)}
      </NavDropdown>
      <NavDropdown.Item
        key="Dr. Moshe Mazel"
        href="/substratum-protocol-scientist-profile-moshe-mazel"
      >
        Dr. Moshe Mazel
      </NavDropdown.Item>
      <NavDropdown.Item
        key="Dr. Burnstein Grok"
        href="/substratum-protocol-scientist-profile-burnstein-grok"
      >
        Dr. Burnstein Grok
      </NavDropdown.Item>
      {/* 
      <NavDropdown title="Tools and Info" id="blade-runner-tools-and-info">
        {renderLinks(toolsLinks)}
      </NavDropdown> */}
    </NavDropdown>
  );
};

export default SPNavBar;
